<template>
  <v-slide-y-transition mode="out-in">
    
  </v-slide-y-transition>
</template>
<script>  
export default {  
  data: () => ({
    
  }),  
  mounted(){
    
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {  
    
  }
}
</script>